'use strict';

module.exports = function(angularModule) {
  angularModule.controller('EmailTemplatesCtrl', function($state, $scope, user, reviewGenService, adminSearchService, pagingService, updateService, stringService, confirmService, userManagerService) {
    var vm = this;

    vm.state = {
      updating: false,
      loading: true
    };

    vm.accountConfig = {
      required : false,
      accountId : null,
      disableDropdown: false,
      showAccountSelection: false
    };

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    }

    vm.pageStrings = stringService.adminStrings();

    vm.canModifyEmailTemplate = function(emailTemplate) {
      return _.includes(user.permissions, "UserManagement") || emailTemplate.creatorId == user.userId
    }

    vm.deleteEmailTemplate = function(emailTemplate) {
      confirmService.confirm('Delete Email', `Are you sure you want to delete the email template, "${emailTemplate.name}?"`, confirmService.DELETE)
        .then(response => {
          if (response) {
            vm.state.updating = true;
            reviewGenService.deleteEmailTemplate(emailTemplate).then(function() {
              var updateInfo = {
                status: "Active",
                type: "emailTemplate",
                title: "Email Template",
                destinationRole: "manage",
                notificationType: "detail",
                actions: [{action:"delete"}],
                entity: emailTemplate,
                id: emailTemplate._id,
                name: emailTemplate.name,
                searchParam: emailTemplate.name
              };
              updateService.registerSuccessfulUpdate(updateInfo,true);

              vm.refreshEmailtemplates(vm.emailTemplateSearchQuery)
            }).finally(() => vm.state.updating = false)
          }
        })
    };

    vm.showSendTestModal = function(emailTemplate) {
      $('#testEmailModal').modal();

      vm.sendTestEmail = function() {
        if (vm.testEmailForm.$valid) {
          reviewGenService.sendTestEmail(emailTemplate, vm.testEmailAddress).then(function(response) {
            // feedback?
          });

          $('#testEmailModal').modal('hide');
        }
      }
    };

    vm.userMap = {};
    vm.refreshEmailtemplates = function(query) {
      vm.state.loading = true;
      vm.emailTemplateSearchQuery = adminSearchService.getSearchQuery();
      reviewGenService.searchEmailTemplates({searchTextOpt: vm.emailTemplateSearchQuery,limitOpt:10000})
        .then(function(response) {
          vm.templates = response.templates;

          if (user.permissions.indexOf("UserManagement") >= 0){
            userManagerService.getUsers(vm.templates.map(template => template.creatorId)).then(userMap => {
              vm.userMap = userMap
              vm.templates.forEach(tpl => {
                if (!vm.userMap[tpl.creatorId]) vm.userMap[tpl.creatorId] = {firstName: "Account", lastName: "Admin"}
              })
            })
          }

          vm.totalEmailtemplatesInResponse = response.count;
          vm.emailTemplatesPaged = pagingService.createPagingData(response.templates, 15, 'name');
          vm.state.loading = false;
        });
    };

    vm.refreshEmailtemplates();

  });
};

